enum DynamicSetupStep {
  SYSTEM_DEFAULTS = 'SYSTEM_DEFAULTS',
  PHONE_NUMBERS = 'PHONE_NUMBERS',
  LOCATIONS = 'LOCATIONS',
  USERS = 'USERS',
  DEVICES = 'DEVICES',
  CONFIRMATION = 'CONFIRMATION',
}

export enum SetupType {
  DYNAMIC_SETUP = 'DYNAMIC_SETUP',
  GUIDED_SETUP = 'GUIDED_SETUP',
  NONE = 'NONE',
}

export interface DynamicSetupConfig {
  completed: boolean
  completedSteps: DynamicSetupStep[]
  excludedSteps: DynamicSetupStep[]
  setupType: SetupType
  shownOnLogIn: boolean
}
